import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('po/inter-branch-transfer/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('po/reports/inter-branch-transfer/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('po/exports/inter-branch-transfer/receivings', { params })
  },

  async show (id) {
    return axios.get(`po/inter-branch-transfer/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/inter-branch-transfer/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/inter-branch-transfer/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/inter-branch-transfer/receivings/${data.id}`, { data })
  }
}

export default ReceivingService
